// extracted by mini-css-extract-plugin
export var dropdown = "_u5-0";
export var imageWrapper = "_u5-3";
export var itemNameContainer = "_u5-1";
export var productImage = "_u5-2";
export var spinnerWrapper = "_u5-4";